// Single shared <audio> element for the TIME commentary track.
let el;

export function getAudio() {
  if (!el) {
    el = new Audio("/audio/intro.mp3");
    el.preload = "auto";
  }
  return el;
}
